import React from 'react';

import type { CustomCSSProperties } from '../../types/pbTypes';
import { getAdvancedSettings } from '../advancedSettings';
import { PageBuilderElementWrapper } from '../PageBuilderElementWrapper';

import type { ButtonType } from './buttonsConfigAggregator';
import classes from './PageBuilderButtons.module.scss';

type PageBuilderButtonProps = ButtonType;

/**
 * Return the PB Buttons
 * @param props
 * @constructor
 */
export function PageBuilderButtons(props: PageBuilderButtonProps) {
    /**
     * Configure the styles requires for the Block
     */
    const advancedSettings = getAdvancedSettings<PageBuilderButtonProps>(props);

    const layoutStyles = {} as CustomCSSProperties;

    if (props.appearance === 'stacked') {
        layoutStyles['flexDirection'] = 'column';

        switch (advancedSettings?.textAlign) {
            case 'center':
                layoutStyles['alignItems'] = 'center';
                break;
            case 'right':
                layoutStyles['alignItems'] = 'flex-end';
                break;
            default:
                layoutStyles['alignItems'] = 'flex-start';
        }
    }

    if (props.appearance === 'inline') {
        layoutStyles['justifyContent'] = advancedSettings.textAlign;
    }

    const buttonsClassNames = [classes['root'], 'pageBuilderButtonsGlobal'];

    if (props.cssClasses && props.cssClasses.length > 0) {
        buttonsClassNames.push(...props.cssClasses);
    }

    if (props.isSameWidth) {
        buttonsClassNames.push(classes['buttonsHaveSameWidth']);
    }

    /**
     * Render the Button UI
     */
    return (
        <PageBuilderElementWrapper
            contentType={props.contentType}
            uniqueID={props.uniqueID}
            styles={{
                ...advancedSettings,
                ...layoutStyles,
            }}
            classNames={buttonsClassNames}
        >
            {props.children}
        </PageBuilderElementWrapper>
    );
}
